import Plot from "react-plotly.js";
import { useMemo } from "react";

export default function BMDPlot({ bmdObjects, doseUnit }) {
  const sorted = useMemo(() => {
  return [...bmdObjects].sort((a, b) => {
    if (a.organ !== b.organ) {
      return a.organ.localeCompare(b.organ);
    }
    return a.bmd - b.bmd;
  });
}, [bmdObjects]);

  const data = useMemo(() => {
    return [
      {
        type: "bar",
        orientation: "h",

        // Encode organ + endpoint into the y labels
        y: sorted.map((d) => `${d.organ} — ${d.endpoint}`),

        x: sorted.map((d) => d.bmd),

        error_x: {
          type: "data",
          array: sorted.map((d) => d.bmd_upper - d.bmd),
          arrayminus: sorted.map((d) =>
            Math.min(d.bmd - d.bmd_lower, d.bmd)
          ),
          thickness: 2,
          width: 6,
          color: "rgba(153,153,153,0.8)",
        },

        marker: {
          color: "rgba(15,138,117,0.8)",
        },
      },
    ];
  }, [sorted]);

  const layout = {
    bargap: 0.35,

    xaxis: {
      title: `BMD (${doseUnit})`,
      ticksuffix: ` ${doseUnit}`,
    },

    yaxis: {
      automargin: true,
      autorange: "reversed",
    },

    margin: {
      l: 160,
      t: 10,
      r: 20,
      b: 40,
    },

    showlegend: false,
  };

  return (
    <Plot
      data={data}
      layout={layout}
      style={{ width: "60vw", height: "50vh" }}
      config={{ staticPlot: true }}
      useResizeHandler
    />
  );
}
